export const LOCATION_TYPES = [{
    value: '1',
    viewValue: 'Worldwide'
},
];